import { render, staticRenderFns } from "./pestsDiseasesDatabase.vue?vue&type=template&id=49b4476e&"
import script from "./pestsDiseasesDatabase.vue?vue&type=script&lang=js&"
export * from "./pestsDiseasesDatabase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports